var map = {
	"./AddToBasket1.png": 7320,
	"./AddToBasket2.png": 2595,
	"./ChhaviAnvaya1.png": 2185,
	"./ChhaviAnvaya2.png": 4002,
	"./CourseManagementSystem1.png": 1647,
	"./CourseManagementSystem2.png": 7156,
	"./FoodOrderingWebsite1.png": 145,
	"./FoodOrderingWebsite2.png": 2714,
	"./NQueenPuzzleGame1.png": 5730,
	"./NQueenPuzzleGame2.png": 873,
	"./PortfolioWebsite1.png": 7554,
	"./Yoga.png": 4861,
	"./YogaAasan1.png": 5576,
	"./YogaAasan2.png": 1331
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3955;